import { Icon } from '@components/generic/Icon';
import React from 'react';

import { Container } from './styles';

export const Notifications: React.FC = () => {
  return (
    <Container>
      <p className="p3">2</p>
      <Icon name="bell" color="textWhite" />
    </Container>
  );
};
